import React from 'react'
import { WebHeaderProps } from './types'
import { View, useDripsyTheme } from 'dripsy'
import useWebHeaderHeight from './use-web-header-height'
import { Platform, StyleSheet } from 'react-native'
import { BlurView } from 'expo-blur'
import SmartArtistSearchInput from '@beatgig/search/components/smart-artist-search-input'
import SmartUserAvatar from '@beatgig/auth-components/smart-user-avatar/_index'
import Logo from '../logo'
import { Link, useRouting } from 'expo-next-react-navigation'
import SmartSignoutLink from '@beatgig/auth-components/smart-signout-link'
import SmartOpenLikesPopupLink from '@beatgig/auth-components/smart-open-likes-link'
import SmartSignUpButton from '@beatgig/auth-components/smart-sign-up-button'
import SmartLinkToBookings from '@beatgig/auth-components/smart-link-to-bookings'

export default function WebHeader({
  sx = {},
  shouldNavigateOnFocus,
}: WebHeaderProps) {
  const { height, top, zIndex } = useWebHeaderHeight()
  const router = useRouting()

  const { space } = useDripsyTheme().theme

  const prefetch = React.useRef(router.prefetch)
  React.useEffect(() => {
    prefetch.current('/search')
  }, [])

  const leftAndRightFlex = [null, 1]

  return (
    <View
      sx={{
        zIndex,
        position: Platform.OS === 'web' ? 'fixed' : 'absolute',
        top: 0,
        right: 0,
        left: 0,
        ...sx,
      }}
    >
      <View
        sx={{
          height,
          // position: Platform.OS === 'web' ? 'fixed' : 'absolute',
          // top: 0,
          // right: 0,
          // left: 0,
          // ...sx,
        }}
      >
        <View sx={{ height: top }} />
        <BlurView
          style={StyleSheet.absoluteFillObject}
          tint="dark"
          intensity={Platform.select({ web: 80, default: 100 })}
        />
        <View
          sx={{ flexDirection: 'row', height: '100%', alignItems: 'center' }}
        >
          <View
            webContainerSx={{
              flex: leftAndRightFlex,
              justifyContent: 'center',
            }}
            sx={{
              flex: leftAndRightFlex,
              justifyContent: 'center',
              pl: [2, 3],
              alignItems: 'flex-start',
            }}
          >
            <Link
              routeName="/"
              web={{
                path: '/',
              }}
              isText={false}
            >
              <Logo size={30} />
            </Link>
          </View>
          <View
            webContainerSx={{ flex: [2, 1.5, null, null, 2] }}
            sx={{ flex: [2, 1.5, null, 2] }}
          >
            <View sx={{ height: '100%' }}>
              <View sx={{ flex: 1, justifyContent: 'center' }}>
                <View
                  sx={{ width: '100%', maxWidth: 800, alignSelf: 'center' }}
                >
                  <View sx={{ px: [2, null, 0] }}>
                    <SmartArtistSearchInput
                      shouldNavigateOnFocus={shouldNavigateOnFocus}
                    />
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View
            sx={{
              height: '100%',
              justifyContent: 'center',
              pr: [2, 3],
              flex: leftAndRightFlex,
              alignItems: 'flex-end',
            }}
            webContainerSx={{
              flex: leftAndRightFlex,
              justifyContent: 'center',
            }}
          >
            <View sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <SmartLinkToBookings
                sx={{ mr: 2, display: ['none', null, 'flex'] }}
              />
              <SmartOpenLikesPopupLink
                sx={{ mr: 2, display: ['none', null, 'flex'] }}
              />
              <SmartSignoutLink
                sx={{ mr: 2, display: ['none', null, 'flex'] }}
              />
              <SmartUserAvatar
                shouldShowWhenUnauthenticated={false}
                sx={{
                  animationKeyframes: {
                    from: {
                      opacity: 0,
                      transform: [
                        {
                          translateX: 5,
                        },
                      ],
                    },
                    to: {
                      opacity: 1,
                      transform: [
                        {
                          translateX: 0,
                        },
                      ],
                    },
                  },
                  animationDuration: '0.25s',
                }}
                size={['small', null, 'medium']}
              />
              <SmartSignUpButton />
            </View>
          </View>
        </View>
      </View>
    </View>
  )
}
